import Axios, { AxiosRequestConfig } from 'axios';
import { getKeycloakParsed, getToken, loginIfRequired } from '../Authentification/authentification';
import createAdherentApi, { IApi as IAdherentApi } from './adherent';
import createAdhesionApi, { IApi as IAdhesionApi } from './adhesion';
import createDepannageApi, { IApi as IDepannageApi } from './depannage';
import createProgrammeApi, { IApi as IProgrammeApi } from './programme';
import createCompteApi, { IApi as ICompteApi } from './compte';
import createFideliteApi, { IApi as IFideliteApi } from './fidelite';
import createModeleCarteApi, { IApi as IModeleCarteApi } from './modeleCarte';
import createReferentielApi, { IApi as IReferentielApi } from './referentiel';

/**
 * Création du client Axios
 */
export const createAxiosClient = (endpoint: string) => {
  const axiosClient = Axios.create({
    baseURL: endpoint,
    // tslint:disable: quotemark
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    // tslint:enable: quotemark
  });

  /**
   * Intercepteur Axios
   */
  axiosClient.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      /**
       * Permet d'ajouter dans le header de nos requêtes les identifiants de connexion.
       */
      const tokenParsed = getKeycloakParsed();
      if (tokenParsed) {
        if (tokenParsed && tokenParsed.exp && tokenParsed.exp * 1000 < Date.now()) {
          sessionStorage.clear();
          localStorage.clear();
          loginIfRequired();
        }
      }
      const token = getToken();
      token && localStorage.setItem('token', token);

      const tokenStorage = localStorage.getItem('token');
      if (tokenStorage !== undefined && tokenStorage !== null) {
        config.headers.common['Authorization'] = `Bearer ${getToken()}`;
      }

      // Do something before request is sent
      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    },
  );

  return axiosClient;
};

/**
 * Crée un nouveau client d'API
 * @param endpoint
 */
const create = (endpoint: string): IApi => {
  const axiosClient = createAxiosClient(endpoint);
  return {
    ...createAdherentApi(endpoint, axiosClient),
    ...createProgrammeApi(endpoint, axiosClient),
    ...createAdhesionApi(endpoint, axiosClient),
    ...createDepannageApi(endpoint, axiosClient),
    ...createCompteApi(endpoint, axiosClient),
    ...createFideliteApi(endpoint, axiosClient),
    ...createModeleCarteApi(endpoint, axiosClient),
    ...createReferentielApi(endpoint, axiosClient),
  };
};

// Fusion des interfaces des API en une interface unique

export type IApi = IAdherentApi &
  IProgrammeApi &
  IAdhesionApi &
  IDepannageApi &
  ICompteApi &
  IFideliteApi &
  IModeleCarteApi &
  IReferentielApi;

export default { create };
